import '../../assets/css/earthwooduser.css'
import React, { useEffect, useState } from "react";
import Leftbar from '../../elements/Leftbar';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../config/global_constants';
import { Box } from '@mui/material';
import Select from "react-select";
import { callBackendAPI } from '../../helpers/common';
import "./AssignRole.css"
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AssignRole = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalPages, setTotalPages] = useState(1);

  const handleSidebarClose = () => setShowSidebar(false);

  // const fetchUsers = async () => {
  //   const apiParams = { request_type: "get", method: "admin/users" };
  //   const response = await callBackendAPI([apiParams]);
  //   // console.log("response===>32",response,response?.data[0]?.data)
  //   if (response.success) {
  //     const data = response?.data[0]?.data || [];
  //     setUsers(data);
  //   }
  // };

  const fetchUsers = async (page = 1, search = "", append = false) => {
    setIsLoadingMore(true);

    try {
      const apiParams = {
        request_type: "get",
        method: `admin/users?page=${page}${search ? `&search=${search}` : ""}`
      };

      const response = await callBackendAPI([apiParams]);

      if (response.success) {
        const responseData = response?.data[0]?.data;
        const newUsers = responseData?.data || [];


        const formattedUsers = newUsers.map((u) => ({
          value: u.id,
          label: `${u.first_name} ${u.last_name} (${u.email})`,
        }));

        if (append) {
          setUsers((prev) => [...prev, ...formattedUsers]);
        } else {
          setUsers(formattedUsers);
        }

        setTotalPages(responseData.last_page || 1);
        setHasMore(responseData.current_page < responseData.last_page);
        setCurrentPage(responseData.current_page || 1);
      }
    } catch (error) {
      console.log("Error fetching:", error);
      toast.error("Failed to fetch users");
    } finally {
      setIsLoadingMore(false);
    }
  };


  const fetchRoles = async () => {
    try {
      const response = await axios.get(`${API_URL}getAllRoles`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });

      // console.log(response?.data?.data, "Fetched roles");

      if (response?.data?.status === 200 && response?.data?.data) {
        setRoles(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      toast.error("Failed to fetch roles");
    }
  };

  useEffect(() => {
    fetchUsers(1, "", false);
    fetchRoles();
  }, []);

  const AssignRole = async (e) => {
    e.preventDefault();

    if (!selectedUser) {
      toast.error("Please select a user");
      return;
    }

    if (!selectedRole) {
      toast.error("Please select a role");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        user_id: selectedUser,
        role_id: selectedRole,
      };

      const response = await axios.post(`${API_URL}assignRole`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });


      const successMessage =
        response?.data?.message ||
        response?.data?.msg ||
        "Role assigned successfully!";

      toast.success(successMessage);

      setSelectedUser(null);
      setSelectedRole(null);
      setTimeout(() => {
        navigate("/getuserwithrole-details");
      }, 1200);
    } catch (error) {
      console.error("Error assigning role:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "An error occurred while assigning role.";

      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  console.log(selectedUser,"selectedUser....")
  console.log(selectedRole,"selectedRole....")

  return (
    <div className="earthwood-layout">
      <div className="leftbar-wrapper">
        <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
      </div>

      <div className="earthwood-user-list">
        <div className="container pt-4">
          <div className="row">
            <div className="col">
              <div className="card mb-4">
                <div className="card-header">
                  <h5 className="mb-0 font-weight-bold">Assign Role</h5>
                </div>

                <div className="card-body">
                  <Box mt={2}>
                    <Row>
                      <Col xl={6} lg={6} md={6} sm={12}>
                        <label className="form-label">Select User</label>
                        <Select
                        
    options={users}
                         
  value={users.find(u => u.value === selectedUser) || null}
                        onChange={(option) => {
    setSelectedUser(option ? option.value : null); 
  }}
  
                          placeholder="Select a user..."
                          onInputChange={(value) => {
                            setSearchTerm(value);
                            fetchUsers(1, value, false);
                          }}


                          onMenuScrollToBottom={() => {
                            if (hasMore && !isLoadingMore) {
                              fetchUsers(currentPage + 1, searchTerm, true);
                            }
                          }}

                          isLoading={isLoadingMore}
                          isClearable
                        />
                      </Col>

                      <Col xl={6} lg={6} md={6} sm={12}>
                        <label className="form-label">Select Role</label>
                        <Select
                          options={roles.map(role => ({
                            value: role.id,
                            label: role.title
                          }))}
                          value={
                            selectedRole
                              ? {
                                value: selectedRole,
                                label: roles.find(r => r.id === selectedRole)?.title
                              }
                              : null
                          }
                          onChange={(option) => setSelectedRole(option?.value || null)}
                          placeholder="Select a role..."
                          isClearable
                        />
                      </Col>
                    </Row>
                  </Box>

                  <button
                    onClick={AssignRole}
                    disabled={loading || !selectedUser || !selectedRole}
                    className="btn submit-btn-template w-auto d-flex justify-content-center align-items-center mt-3"
                  >
                    {loading && <i className="pi pi-spin pi-spinner" style={{ marginRight: '8px' }}></i>}
                    <span>{loading ? "Assigning Role..." : "Assign Role"}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignRole;